import request from '@/utils/request'
import { method } from '@/utils/constant'
import { formatCountdown } from 'antd/lib/statistic/utils'

const { POST, GET } = method

export default {
  // 编辑基本信息
  async editBasicInfo(params) {
    return request({
      method: POST,
      url: '/member/member/basisinfo',
      params: {
        ...params,
      },
    })
  },

  // 编辑其他信息
  async editOtherInfo(params) {
    return request({
      method: POST,
      url: '/member/member/otherinfo',
      params: {
        ...params,
      },
    })
  },

  // 上传企业Logo
  async uploadLogo(params) {
    return request({
      method: POST,
      url: '/member/member/upload/logo',
      params: {
        ...params,
      },
    })
  },

  // 添加缴费信息
  async memberPayment(params) {
    return request({
      method: POST,
      url: '/member/member/save/memberpayment',
      params: {
        ...params,
      },
    })
  },

  // 查看缴费列表
  async getPaymentList(params) {
    return request({
      method: POST,
      url: '/member/member/payment/list',
      params: {
        ...params,
      },
    })
  },

  // 查看历史会员证
  async getMemberList(params) {
    return request({
      method: POST,
      url: '/member/member/card/list',
      params: {
        ...params,
      },
    })
  },

  // 保存上报文件
  async saveUploadfiles(params) {
    return request({
      method: POST,
      url: '/member/member/uploadfiles',
      params: {
        ...params,
      },
    })
  },

  // 完成上报
  async completeReport(params) {
    return request({
      method: POST,
      url: '/member/member/report',
    })
  },

  // 入会申请表模板下载
  async downloadTemplate(params) {
    return request({
      method: GET,
      url: '/member/member/downloadWord',
    })
  },

  // 入会申请表模板上传
  async uploadApplication(params) {
    return request({
      method: POST,
      url: '/member/member/upload/applicationWord',
      params: {
        ...params,
      },
    })
  },

  // 上传企业营业执照
  async uploadBusinessLicense(params) {
    return request({
      method: POST,
      url: '/member/member/uploadBusinessLicense',
      params: {
        ...params,
      },
    })
  },

  // 上传资质文件
  async uploadQualificationFiles(params) {
    return request({
      method: POST,
      url: '/member/member/uploadQualificationFiles',
      params: {
        ...params,
      },
    })
  },

  // 换证申请
  async changeCredential() {
    return request({
      method: GET,
      url: '/member/member/applyChangeCert',
    })
  },

  // 企业信息变更
  async saveMemberUserChange(params) {
    return request({
      method: POST,
      url: '/member/member/saveMemberUserChange',
      params,
    })
  },

  // 有变更信息的才能get到东西
  async getMemberUserChange() {
    return request({
      method: GET,
      url: '/member/member/getMemberUserChange',
    })
  },

  async selectMemberCardLog() {
    return request({
      method: GET,
      url: '/member/member/selectMemberCardLog',
    })
  },

  async association(associationId) {
    return request({
      method: POST,
      url: '/member/member/association',
      params: {
        associationId,
      },
    })
  },

  async getReplySuccessInfo(id) {
    return request({
      method: GET,
      url: '/member/member/getReplySuccessInfo/' + id,
    })
  },

  async updateApplyRecordInfo() {
    return request({
      method: POST,
      url: '/member/member/updateApplyRecordInfo',
    })
  },
}
